import React from "react";

const OmSaiTeamSection = () => {
  const styles = {
    container: {
      textAlign: "center",
      padding: "40px 20px",
      background: "linear-gradient(180deg, #000b3e 0, #020202 59%)",
      fontFamily: "'outfit,sans-serif",
    },
    heading: {
      fontSize: "37px",
      fontWeight: "600",
      marginBottom: "30px",
      color: "#fff",
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "center",
      gap: "40px",
      flexWrap: "wrap",
      width:"100%"
    },
    button: {
      padding: "20px 45px",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#000",
      backgroundColor: "#gray",
      border: "none",
      borderRadius: "12px",
      boxShadow: "0 4px 6px rgba(139, 80, 80, 0.1)",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    buttonHover: {
      backgroundColor: "#gray",
      transform: "translateY(-2px)",
    },
  };

  const handleHover = (e, entering) => {
    Object.assign(e.target.style, entering ? styles.buttonHover : styles.button);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Join Our Om Sai Team</h2>
      <div style={styles.buttonGroup}>
        {["NBFCs & Banks", "Consulting Services", "Career Opportunities"].map(
          (text, index) => (
            <button
              key={index}
              style={styles.button}
              onMouseEnter={(e) => handleHover(e, true)}
              onMouseLeave={(e) => handleHover(e, false)}
            >
              {text}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default OmSaiTeamSection;
